import { TypeActivityPlatform } from "../domain/TypeActivityPlatform.model";
import { TypeActivityPlatformApi } from "../infrastructure/models/type-activity-platform-api.model";

export function SetMapTypeActivityPlatforms(
    typeActivityPlatforms: TypeActivityPlatformApi[]
): TypeActivityPlatform[] {
    return typeActivityPlatforms.map(SetMapTypeActivityPlatform);
}

export function SetMapTypeActivityPlatform(
    typeActivityPlatform: TypeActivityPlatformApi
): TypeActivityPlatform {
    const {
        ID,
        CreatedAt,
        UpdatedAt,
        DeletedAt,
        name,
        createdBy,
        updatedBy,
        activities,
        ...rest
    } = typeActivityPlatform;

    return {
        id: ID,
        createdAt: CreatedAt,
        updatedAt: UpdatedAt,
        deletedAt: DeletedAt,
        name: name,
        createdBy: createdBy,
        updatedBy: updatedBy,
        activities: activities,
        ...rest
    };
}